
// @ts-nocheck





import { i18nText } from '@/locales';


import {Component, Watch} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {DisplayMasks} from "@/UI/mixins/DisplayMasks";
import {Table} from "ant-design-vue";
import {FiltersData} from "@/entity/filters/extFilter";
import {HandleScrollStore, SearchinStore} from "@/UI/Decorators/decorator";
import {getStudioId} from "@/UI/lib/state";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {TableColumns} from "@/UI/pages/clients/lib/table";
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
import {SourcesStore} from '@/store/modules/Sources';
import {ClientsStore} from "@/store/modules/Clients";
import {ClientCategoryStore} from "@/store/modules/ClientsCategory";
import {ProxyGetData} from "@/UI/components/Helpers/getData";
import FilterTableComponent from "@/UI/components/Helpers/filterAndSorted/FilterTableComponent.vue"
import {appPaginationStore} from "@/store/modules/appPagination";

@Component({
  components: {
    BaseDataForm,
    "a-table": Table,
    PageTitle,
    SortComponent,
    FilterTableComponent
  },
})

export default class Clients extends mixins(
    DisplayMasks,
    ProxyGetData,
    TableColumns,
    appPaginationStore
) {
  filtersData = new FiltersData();

  @Watch('proxyFilter', {deep: true})
  onClientFilterChanged(): void {
    if (this.filter_load) this.onApplyFilters();
  }

  clientRow(record: any): any {
    return {style: {cursor: 'pointer'}, on: {click: (event: MouseEvent) => {
      if (!(event.target as HTMLElement).closest('a, button, input')) {
        this.$router.push({name: 'ClientDetailCommon', params: {id: String(record.id)}});
      }
    }}};
  }

  linkClientCreate(): void {
    this.$router.push({
      name: this.$routeRules.clientCreate,
      params: {
        Studio: getStudioId(this)
      }
    });
  }

  @SearchinStore
  hSearch(source: string, value: string): void {
  }

  @HandleScrollStore
  hScroll(event: any, value: string): void {
  }

  handleSearch(source: string, value: string): void {
    this.hSearch(source, value)
  }

  handleScroll(event: any, value: string): void {
    this.hScroll(event, value)
  }

  async created(): Promise<void> {
    try {
      this.proxyFilter = {
        salon_id: getStudioId(this)
      }
      appPaginationStore.setCurrent(1)
      await this.sortedData('desc', {dataIndex: 'created_at'})
      await this.fetchModules([
        {s: 'category', p: {limit: -1}}
      ])
      await SourcesStore.fetchAll();
      this.setFilters(this)
    } catch (e) {
      console.log(e)
    } finally {
      this.formReady = true
    }
  }

  get client(): any {
    return ClientsStore.clients
  }

  get clientCategory(): any {
    return ClientCategoryStore.category
  }

  setFilters(that: any): void {
    this.filtersData.filters.push(
        {
          key: 1, type: 'input', label: i18nText('Имя'), placeholder: i18nText('Имя'),
          onChange(event: any) { that.filterData({name: event.target.value}); }
        },
        {
          key: 8, type: 'input', label: i18nText('Телефон'), placeholder: i18nText('Телефон'),
          onChange(event: any) { that.filterData({phone: event.target.value.replace(/\D/g, '')}); }
        },
        {
          key: 9, type: 'select', label: i18nText('Источник'), default_value: [i18nText('Не указано')],
          value: [{key: '0', label: i18nText('Не указано')}, ...SourcesStore.sources.map(source => ({key: String(source.id), label: source.name}))],
          onChange(value: any) { that.filterData({source_id: value}); }
        },
        {
          key: 2,
          type: "range-input",
          label: i18nText("Продано, ₽"),
          async okRange(key1: any, key2: any) {
            await that.filterData({
              sold_from: key1,
              sold_to: key2
            })
          },
          async onScroll() {
          },
          async onFocus() {
          },
          async onSearch() {
          }
        },
        {
          key: 3,
          type: "range-input",
          label: i18nText("Посещений"),
          async okRange(key1: any, key2: any) {
            await that.filterData({
              count_from: key1,
              count_to: key2
            })
          },
        },
        {
          key: 4,
          type: "datetimerange",
          label: i18nText("Есть записи"),
          async onChange(value: any) {
            let filter = {}
            if (value.length === 0) {
              filter = {
                exist_records_from: '0',
                exist_records_to: '0'
              }
            } else {
              filter = {
                exist_records_from: value[0].format("DD.MM.YYYY"),
                exist_records_to: value[1].format("DD.MM.YYYY")
              }
            }
            that.proxySorting = {
              sort: '',
              by: ''
            }
            await that.filterData(filter)
          },
        },
        {
          key: 5,
          type: "datetimerange",
          label: i18nText("Нет записей"),
          async onChange(value: any) {
            let filter = {}
            if (value.length === 0) {
              filter = {
                not_exist_records_from: '0',
                not_exist_records_to: '0'
              }
            } else {
              filter = {
                not_exist_records_from: value[0].format("DD.MM.YYYY"),
                not_exist_records_to: value[1].format("DD.MM.YYYY")
              }
            }
            await that.filterData(filter)
          },
        },
        {
          key: 6,
          type: "sourceVuex",
          label: i18nText("Категория"),
          vuexSource: "category",
          storeVuexSource: "category",
          default_value: [i18nText("Не указано")],
          async onChange(value: any) {
            await that.filterData({
              category_id: value
            })
          },
          async onScroll() {
          },
          async onFocus() {
          },
          async onSearch() {
          }
        },
        {
          key: 7,
          type: 'select',
          label: i18nText("Долг"),
          default_value: [i18nText("Не указано")],
          value: [
            {
              label: i18nText("Не указано"),
              key: '0'
            },
            {
              label: i18nText("Да"),
              key: '1'
            },
            {
              label: i18nText("Нет"),
              key: '2'
            }
          ],
          async onChange(value: any) {
            await that.filterData({
              debt: value
            })
          },
          async onScroll() {
          },
          async onFocus() {
          },
          async onSearch() {
          }
        }
    )
    this.filter_load = true
  }

  async setFilter({by, sort}): void {
      await this.sortedData(by, {dataIndex: sort.dataIndex})
  }

  async clearAFilter(): void {
      this.proxyFilter = {
        salon_id: getStudioId(this)
      }
      this.proxySorting = {sort: 'created_at', by: 'desc'};
      await this.onApplyFilters();
  }

  async clearFilter(clear: string): void {
    await this.sortedData('desc', {dataIndex: 'created_at'})
  }
}
